export const isArrayEqual = (x, y) => {
  // Check if both arrays are of the same length
  if (x.length !== y.length) {
    return false;
  }

  // Helper function to check if an object exists in an array
  const objectExistsInArray = (array, obj) =>
    array.some(item => item.id === obj.id && item.quantity === obj.quantity);

  // Ensure every object in x exists in y and every object in y exists in x
  return (
    x.every(item => objectExistsInArray(y, item)) &&
    y.every(item => objectExistsInArray(x, item))
  );
};
